import { AppFrameContextService, AppServerAPI } from '@sdbn/common';
import { CustomFilter } from './model/custom-filter';
import { EventEmitter, Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class TMCCommonContextService {

  customFilters: CustomFilter[] = [];

  changed = new EventEmitter<void>();

  constructor(
    appFrameContextService: AppFrameContextService,
    private appServerAPI: AppServerAPI
  ) {

    appFrameContextService.tenant.subscribe(tenant => {
      if (tenant != undefined) {
        this.appServerAPI.execute<any>('/client-configuration/yardconfig', {}).subscribe(yardConfig => {
          this.setFilters(yardConfig.customFilters);
          this.changed.emit();
        });
      }

    });

  }

  public setFilters(filters: CustomFilter[]) {
    for (const filter of filters) {
      this.customFilters.push(new CustomFilter(filter));
    }
  }

}
